import { useState, useCallback, useEffect } from "react";
import { testAuth } from "@/api/adminApi";

export function useAuth() {
  const [authed, setAuthed] = useState<boolean | null>(null); // null = checking
  const [error, setError] = useState("");

  // Check on mount if there's a stored password
  useEffect(() => {
    const stored = sessionStorage.getItem("admin_password");
    if (!stored) {
      setAuthed(false);
      return;
    }
    testAuth().then((ok) => {
      if (!ok) sessionStorage.removeItem("admin_password");
      setAuthed(ok);
    });
  }, []);

  const login = useCallback(async (password: string) => {
    setError("");
    sessionStorage.setItem("admin_password", password);
    const ok = await testAuth();
    if (ok) {
      setAuthed(true);
    } else {
      sessionStorage.removeItem("admin_password");
      setError("Wrong password");
      setAuthed(false);
    }
    return ok;
  }, []);

  const logout = useCallback(() => {
    sessionStorage.removeItem("admin_password");
    setAuthed(false);
  }, []);

  return { authed, login, logout, error };
}
